/* ============================================================
   PEMECAH MASTER PROMPT → BLOCKS  (module GOYANG)
   ============================================================
   Dipakai oleh prototaip ProStudio → Blocks.

   ⭐ SEMPADAN IKUT PENANDA TEKS, BUKAN NOMBOR BARIS.
      Master prompt diedit oleh admin melalui webapp. Kalau pemecah ini
      memakai nombor baris, satu suntingan kecil menggeser semuanya dan
      setiap block memaparkan teks yang salah — TANPA sebarang ralat.
      Penanda teks pula sama ada dijumpai atau tidak, dan kalau tidak
      dijumpai kita MELONTAR ralat (lihat nota "gagal dengan kuat").

   ⭐ PECAHAN INI TIDAK MENGUBAH SATU AKSARA PUN.
      `potongan.map(p => p.teks).join('')` mesti sama TEPAT dengan teks
      asal. `pecahMasterPrompt` mengesahkannya sendiri sebelum pulang.
      Sebabnya: pelanggan menghidupkan Pro Mode tanpa mengubah apa-apa
      mesti mendapat hasil yang SAMA seperti hari ini. Kalau pecahan
      menelan walau satu baris, perbezaan hasil itu mustahil dijejaki.

   ⛔ GAGAL DENGAN KUAT, BUKAN SENYAP.
      Kalau mana-mana penanda hilang (admin menyunting tajuk seksyen),
      fungsi ini melontar ralat yang menamakan penanda itu. Jangan
      tukar kepada "langkau sahaja yang tiada" — pelanggan akan dapat
      prompt yang kekurangan satu peraturan tanpa sesiapa perasan.

   Keputusan user 2026-09-09:
     • Teks asal masuk KE DALAM kotak Instruction sepenuhnya. Kotak
       Example dibiar KOSONG — kita tidak mencungkil "mana contoh,
       mana arahan" bagi pihak user.
     • Bahagian `jenis: 'plumbing'` bukan block: tajuk prompt,
       pengisytiharan 5 nama medan, dan blok FORMAT OUTPUT JSON.
       Kalau ia berubah, hasilnya bukan lain — hasilnya KOSONG.
   ============================================================ */

/* Turutan WAJIB sama seperti turutan dalam master prompt. Setiap
   penanda dicari BERMULA selepas penanda sebelumnya, jadi teks yang
   kebetulan berulang di tempat lain tidak boleh menipu pemecah. */
export const SEMPADAN_GOYANG = [
    { id: 'p0', nama: 'Prompt header', penanda: '## MASTER PROMPT:', jenis: 'plumbing' },
    { id: 'b1', nama: 'Role & job', penanda: '**PERANAN GPT:**', jenis: 'blok' },
    { id: 'b2', nama: 'Hand selection', penanda: '**⚠️ RULE WAJIB — PEMILIHAN TANGAN', jenis: 'blok' },
    { id: 'b3', nama: 'Voiceover gender', penanda: '**⚠️ RULE WAJIB — VOICEOVER GENDER', jenis: 'blok' },
    { id: 'b4', nama: 'Camera framing', penanda: '**⚠️ RULE WAJIB — CAMERA FRAMING', jenis: 'blok' },
    { id: 'p1', nama: 'Output fields', penanda: '**ARAHAN KANDUNGAN', jenis: 'plumbing' },
    { id: 'b5', nama: 'Image prompt', penanda: '**1) promptImage**', jenis: 'blok' },
    { id: 'b6', nama: 'Video prompt', penanda: '**2) promptVideo', jenis: 'blok' },
    { id: 'b7', nama: 'Do not / constraints', penanda: '**⚠️ PANTANG LARANG**', jenis: 'blok' },
    { id: 'b8', nama: 'Hook text', penanda: '**3) hookText', jenis: 'blok' },
    { id: 'b9', nama: 'Video script — structure', penanda: '**4) videoScript', jenis: 'blok' },
    { id: 'b10', nama: 'Video script — price rule', penanda: '* 🚫 RULE COMPLIANCE — JANGAN SEBUT HARGA', jenis: 'blok' },
    { id: 'b11', nama: 'Video script — banned words', penanda: '* 🚫 RULE COMPLIANCE — JANGAN GUNA LANGUAGE EXTERNAL REDIRECT', jenis: 'blok' },
    { id: 'b12', nama: 'Video script — tone', penanda: '* 🔴 TONE:', jenis: 'blok' },
    { id: 'b13', nama: 'Caption', penanda: '**5) captionTiktok**', jenis: 'blok' },
    { id: 'p2', nama: 'Output format', penanda: '**FORMAT OUTPUT (JSON SAHAJA):**', jenis: 'plumbing' },
];

/* Master prompt disimpan sebagai objek 3-mod. GOYANG hanya memakai
   mod pertama (disahkan pada peti besi 2026-09-09: mod 2 dan 3 kosong),
   tetapi format lama sebagai satu rentetan masih mungkin wujud. */
export function ambilTeksMod(masterPrompt) {
    if (!masterPrompt) return '';
    if (typeof masterPrompt === 'string') return masterPrompt;
    if (typeof masterPrompt !== 'object') return '';
    const utama = masterPrompt.mode1_noAvatarNoGender;
    if (typeof utama === 'string' && utama.trim()) return utama;
    /* Sandaran: mod pertama yang ada isi. Jangan pulang kosong senyap
       hanya kerana nama medan bertukar suatu hari nanti. */
    const isi = Object.values(masterPrompt).find((v) => typeof v === 'string' && v.trim());
    return isi || '';
}

export function pecahMasterPrompt(teks, sempadan = SEMPADAN_GOYANG) {
    if (typeof teks !== 'string' || !teks.trim()) {
        throw new Error('Master prompt kosong — tiada apa untuk dipecahkan.');
    }

    const kedudukan = [];
    let dari = 0;
    for (const s of sempadan) {
        const i = teks.indexOf(s.penanda, dari);
        if (i === -1) {
            throw new Error(`Penanda tidak dijumpai dalam master prompt: "${s.penanda}". Master prompt mungkin sudah disunting — sempadan block perlu dikemas kini.`);
        }
        kedudukan.push(i);
        dari = i + s.penanda.length;
    }

    const potongan = sempadan.map((s, i) => {
        /* Potongan PERTAMA bermula dari 0, bukan dari penandanya —
           supaya apa-apa baris kosong di hadapan tidak hilang dan
           semakan "tiada aksara hilang" di bawah kekal benar. */
        const mula = i === 0 ? 0 : kedudukan[i];
        const hingga = i === sempadan.length - 1 ? teks.length : kedudukan[i + 1];
        return { ...s, teks: teks.slice(mula, hingga) };
    });

    const semula = potongan.map((p) => p.teks).join('');
    if (semula !== teks) {
        throw new Error('Pecahan block tidak sepadan dengan master prompt asal — ada aksara hilang atau bertindih. Dibatalkan.');
    }

    return potongan;
}

/* Bentuk yang skrin pakai: hanya bahagian `blok`, dengan teks asal
   dimasukkan ke dalam Instruction dan Example dibiar kosong. */
export function blokDariMasterPrompt(masterPrompt) {
    const teks = ambilTeksMod(masterPrompt);
    const potongan = pecahMasterPrompt(teks);
    return {
        blocks: potongan
            .filter((p) => p.jenis === 'blok')
            .map((p) => ({
                id: p.id,
                nama: p.nama,
                mod: 'ai',
                arahan: p.teks.trim(),
                contoh: '',
                teks: '',
            })),
        plumbing: potongan.filter((p) => p.jenis === 'plumbing').map((p) => p.nama),
        jumlahAksara: teks.length,
    };
}
